export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-align-left-3693cc1eab502a08f0b08bfa2bc4bd20.svg";